<label class="distance-filter" [ngClass]="{'selected': distanceValue !== '', 'distance-filter--disabled' :  disabled}">
  <div class="distance-filter__icon"><brt-icon [icon]="'radius'"></brt-icon></div>

  <div class="distance-filter__label">{{distanceValue !== "" ? distanceValue + "km" : "Umkreis"}}</div>

  <div class="distance-filter__arrow"><brt-icon [icon]="'dropdown'"></brt-icon></div>

  <div class="distance-filter__select-wrapper">
    <select name="" [(ngModel)]="distanceValue" (ngModelChange)="valueChanged($event)" [disabled]="disabled">
      <option value="0">Alle</option>
      <option value="30">30km</option>
      <option value="50">50km</option>
      <option value="80">80km</option>
      <option value="100">100km</option>
      <option value="120">120km</option>
    </select>
  </div>
</label>
